import type {WorkspaceCapabilityType} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityType";
import type {WorkspaceCapabilityUdoTemplateConfiguration} from "@vesta/vos-types/modules/workspaceLevel/workspaceCapabilities/workspaceCapabilities/domain/WorkspaceCapabilityUdoTemplateConfiguration";
import {z as zod} from "zod";

export type OttopilotLeaderboardWorkspaceCapabilityUdoBindings = WorkspaceCapabilityUdoTemplateConfiguration<WorkspaceCapabilityType.ottopilotLeaderboard> & {
    // Capability-specific UDO bindings, such as dynamically created templates, belong here.
};

export const ottopilotLeaderboardWorkspaceCapabilityUdoBindingsValidator = zod.strictObject({
    fixedUdoTemplates: zod.strictObject({}),
}) satisfies zod.ZodType<OttopilotLeaderboardWorkspaceCapabilityUdoBindings>;
